import { combineReducers } from 'redux';
import authReducer from '../components/login/reducers/authReducer'
import automationReducer from '../components/automation/reducers/automationReducer'

export default combineReducers({
    auth: authReducer,
    automation: automationReducer
});